import { Component, Vue, Emit } from 'vue-property-decorator';
import axios, {AxiosRequestConfig} from 'axios'
import {userInviteList} from "@/types/Component"
import {invitationDetails} from "@/types/Component"

@Component
export default class UserList extends Vue {

    isUserInviteModal = false;
    userInviteMail = "";
    isEnabled = true;
    isCheckAllEnable = true;
    cancelEnabled = true;
    emailAddresses: string[] = []
  private userInviteList= [] as userInviteList;
  private sortByEmailIsAsc = false
  private sortByNameIsAsc = false
  private sortByAuthorityIsAsc = false
  private sortByApproveDateIsAsc = false
  private sortByInviteDateIsAsc = false
  private selectedItems = [] as string[]
  private invitationId = [] as string[]
  selectAll= false
  private invitationDetails= [] as invitationDetails;
  private localDeleteParams =[] as string[]
  private cgDeleteParams =[] as string[]
  private inviteBtnDisable=false

    created() {
      this.getUserInviteList();
      const loginUserRole = this.$store.getters.loginUser.role;
        if (loginUserRole.includes('ADMIN') && loginUserRole.includes('CONTRACT_ADMIN')){
        this.getUserInviteDetails()
        }else{
          this.inviteBtnDisable =true
        }
    }
   private  createUserInviteList (){
    const inviteDetailsPostForm =this.invitationDetails
     this.$apiClient.doRequest('post',`/userlist`,inviteDetailsPostForm).then((res) =>{
      this.getUserInviteList()
     })
    .catch((error) =>console.log (error))
   }

   private  getUserInviteList (){
    const data = this.$store.getters.tenantId;
     this.$apiClient.doRequest('get',`/userlist/${data}`).then((res) =>{
    this.userInviteList = res.userInvitations;
    const userApproved = this.userInviteList.filter(user => user.created !== null);
    const userInvited = this.userInviteList.filter(user => user.created === null);
    this.userInviteList = userApproved.concat(userInvited);
    const isIdNotExist = this.userInviteList.find((item:any)=> item.id)
         isIdNotExist ? this.isCheckAllEnable = false : this.isCheckAllEnable = true
    })
    .catch((error) =>console.log (error))
   }

   public async getUserInviteDetails() {
    const tenantId = this.$store.getters.tenantId
    const params = this.selectedItems
    this.$apiClient.cloudGearRequest('get',`${tenantId}/invitations`, params).then((res)=>{
    this.invitationDetails=res;
    this.createGetUserInviteList();
    }).catch((error)=>{
    if (error.status === 401) {
      this.$toasted.error("アクセストークンが不正または有効期限切れです。")
    }
    if (error.status === 400) {
      this.$toasted.error("入力値が不足しているか不正です。" + error.data?.message);
    }
    if (error.status === 403) {
      this.$toasted.error("リクエストの実行に必要な権限が不足しています")
    }
    if (error.status === 404) {
      this.$toasted.error("リクエストされたリソースは存在しません。")
    }
    })
    }

    public createGetUserInviteList(){
        this.$apiClient.doRequest('post',`/userlist/invitations`,this.invitationDetails).then((res) =>{
          this.getUserInviteList();
        })
        .catch((error) =>console.log (error))
      }

   public  userInviteCancel() {
    const params = this.selectedItems
    this.userInviteList.map((item:any)=>{
        if (item.errorMessage ==null && this.invitationId !=null && params.includes(item.id)){
          this.cgDeleteParams.push(item.invitationId)
        }
        else if(item.errorMessage !=null && params.includes(item.id)){
          this.localDeleteParams.push(item.id)
        }
   })
     if(this.cgDeleteParams.length){
      this.deleteCgUserIviteList()
      this.deleteUserInvite();
     }
     else if(this.localDeleteParams.length){
      this.deleteUserInvite();
    }
    }

  private deleteCgUserIviteList(){
   const tenantId = this.$store.getters.tenantId
      this.$apiClient.cloudGearRequest('delete',`${tenantId}/invitations`, this.cgDeleteParams).then((res)=>{
        this.invitationId = this.cgDeleteParams;
        const loginUserRole = this.$store.getters.loginUser.role;
        if (loginUserRole.includes('ADMIN') && loginUserRole.includes('CONTRACT_ADMIN')){
        this.getUserInviteDetails()
        }else{
          this.inviteBtnDisable =true
        }
        this.cancelEnabled=true;
        this.selectedItems=[];
        this.cgDeleteParams=[];
        this.selectAll = false;
        this.$toasted.success("リクエストは正常に完了しました。");
   }).catch((error)=>{
     if (error.status === 401) {
       this.$toasted.error("アクセストークンが不正または有効期限切れです。")
     }
     if (error.status === 400) {
       this.$toasted.error("入力値が不足しているか不正です。" + error.response.data?.message);
     }
     if (error.status === 403) {
       this.$toasted.error("リクエストの実行に必要な権限が不足しています")
     }
     if (error.status === 404) {
       this.$toasted.error("リクエストされたリソースは存在しません。")
     }
   })
    }

    private deleteUserInvite() {
      const params = this.localDeleteParams;
      this.$apiClient.doRequest('delete',`/userlist`,params).then((res) =>{
        this.selectAll = false;
        this.localDeleteParams=[];
        this.getUserInviteList()
      })
      .catch((error) =>console.log (error))
    }

    public async handleInvite(){
      const tenantId = this.$store.getters.tenantId
      const currentDate = new Date();
      const futureDate = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);
      const result = futureDate.getTime();
      
     const params = {
        "mailAddresses":this.emailAddresses,
        "expires": result
      }
     this.$apiClient.cloudGearRequest('post',`${tenantId}/invitations`, params).then((res)=>{
         this.invitationDetails =res;
         this.cancel();
         this.createUserInviteList();
         Vue.toasted.success("リクエストは正常に完了しました。");
    }).catch((error)=>{
      this.cancel();
      const params = this.emailAddresses.map(item=>{
        return {
        "mail_address":item,
        "error_message" : error.data?.message || "入力値が不足しているか不正です。"
        }
      })
      this.$apiClient.doRequest('post',`/userlist/userInviteMail`,params).then((res) =>{
        this.getUserInviteList()
       })
      .catch((error) =>console.log (error))
          if (error.status === 401) {
            this.$toasted.error("アクセストークンが不正または有効期限切れです。")
          }
          if (error.status === 400) {
            this.$toasted.error("入力値が不足しているか不正です。");
          }
          if (error.status === 403) {
            this.$toasted.error("リクエストの実行に必要な権限が不足しています")
          }
          if (error.status === 404) {
            this.$toasted.error("リクエストされたリソースは存在しません。")
          }
      })
    }

    userInviteCheckBoxAll() {
      if (this.selectAll) {
        this.cancelEnabled=false;
        this.selectedItems = this.userInviteList.filter(userInvite => userInvite.id!=null).map(userInvite => userInvite.id);
      } 
      else{
        this.cancelEnabled=true;
        this.selectedItems=[]
      }
    }

    userInviteSingleCheckBox() {
      const invitedUserArr = this.userInviteList.filter(item=> item.id);
      if (this.selectedItems.length === invitedUserArr.length) {
        this.cancelEnabled=false;
        this.selectAll = true;
      } 
      else{
        this.selectedItems.length ? this.cancelEnabled=false :this.cancelEnabled=true ;
        this.selectAll = false;
      }
    }

    sortByEmail(isSwitchAsc?: boolean) {
      this.sortByEmailIsAsc = isSwitchAsc ? !this.sortByEmailIsAsc : this.sortByEmailIsAsc
      this.userInviteList.sort((a, b) => {
        const combinedA = (a.loginId || '') + (a.mailAddress || '');
        const combinedB = (b.loginId || '') + (b.mailAddress || '');
      return this.sortByEmailIsAsc ? combinedA.localeCompare(combinedB) :combinedB.localeCompare(combinedA);
      })
    }

    sortByName(isSwitchAsc?: boolean) {
      this.sortByNameIsAsc = isSwitchAsc ? !this.sortByNameIsAsc : this.sortByNameIsAsc
      this.userInviteList.sort((a, b) => {
          if (a.name === null && b.name === null) {
            return 0;
          } else if (a.name === null) {
            return 1;
          } else if (b.name === null) {
            return -1;
          } else {
            return this.sortByNameIsAsc ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
          }
      })
    }
    sortByAuthority(isSwitchAsc?: boolean) {
      this.sortByAuthorityIsAsc = isSwitchAsc ? !this.sortByAuthorityIsAsc : this.sortByAuthorityIsAsc
      this.userInviteList.sort((a, b) => {
        if (a.authority === null && b.authority === null) {
          return 0;
        } else if (a.authority === null) {
          return 1;
        } else if (b.authority === null) {
          return -1;
        } else {
          return this.sortByAuthorityIsAsc ? a.authority.localeCompare(b.authority) : b.authority.localeCompare(a.authority)
        }
      })
    }

    sortByApproveDate(isSwitchAsc?: boolean) {
    this.sortByApproveDateIsAsc = isSwitchAsc ? !this.sortByApproveDateIsAsc : this.sortByApproveDateIsAsc
    this.userInviteList.sort((a, b) => {
    if (a.created === null && b.created === null) {
    return 0;
    } else if (a.created === null) {
    return 1;
    } else if (b.created === null) {
    return -1;
    } else {
    return this.sortByApproveDateIsAsc ? Date.parse(a.created) - Date.parse(b.created) : Date.parse(b.created) - Date.parse(a.created)
       }
      })
    }

    sortByInviteDate(isSwitchAsc?: boolean) {
    this.sortByInviteDateIsAsc = isSwitchAsc ? !this.sortByInviteDateIsAsc : this.sortByInviteDateIsAsc
    this.userInviteList.sort((a, b) => {
    if (a.inviteDate === null && b.inviteDate === null) {
      return 0;
    } else if (a.inviteDate === null) {
      return 1;
    } else if (b.inviteDate === null) {
    return -1;
    } else {
    return this.sortByInviteDateIsAsc ? Date.parse(a.inviteDate) - Date.parse(b.inviteDate) : Date.parse(b.inviteDate) - Date.parse(a.inviteDate)
    }
    })
    }

    private dateFormat(date: Date) {
    if(date){
      const year = new Date(date).getFullYear();
      const month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
      const day = ("0" + new Date(date).getDate()).slice(-2);
      return year + '/' + month + '/' + day;
    }
    return "-";
    }

    @Emit()
    cancel(){
      this.isUserInviteModal = false
      this.userInviteMail ='';
    }

    handleValidateMail(){
      this.emailAddresses =this.userInviteMail.split("\n");
      const mailRegx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      const allElements = this.emailAddresses.some(item=> !mailRegx.test(item))
      allElements ? this.isEnabled = true : this.isEnabled = false
    }

}